import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		// pathname has changed, therefore scroll to top is necessary
		console.debug(pathname);
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}
